module.exports = __webpack_public_path__ + "static/media/robin.fe1f4389.jpg";